import { render } from "./FilterSegment.vue?vue&type=template&id=3cb43221"
import script from "./FilterSegment.vue?vue&type=script&lang=js"
export * from "./FilterSegment.vue?vue&type=script&lang=js"
script.render = render

export default script